import { render, staticRenderFns } from "./DataGridGroupCellText.vue?vue&type=template&id=57274acf"
import script from "./DataGridGroupCellText.vue?vue&type=script&lang=js"
export * from "./DataGridGroupCellText.vue?vue&type=script&lang=js"
import style0 from "./DataGridGroupCellText.vue?vue&type=style&index=0&id=57274acf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports